/**
 * TÄLU · Medalla TERNERO 3D · vaivén pitch dinámico
 * Diego 2026-05-09
 *
 * Anima la camera-orbit de cada <model-viewer.is-medallion-3d> con
 * un yaw constante (rotación Y) + pitch sinusoidal (vaivén arriba-abajo)
 * para que NO se sienta plano.
 *
 * Cero interacción: el cursor no afecta nada.
 */
(function () {
  'use strict';

  function initMedallions(){
    const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    const medallions = document.querySelectorAll('model-viewer.is-medallion-3d');
    if (!medallions.length) return;

    medallions.forEach((mv, idx) => {
      // Diego 2026-05-14: medallas con .is-static SIEMPRE fijas frontal upright (sin tick, sin cardan-breath)
      const isStatic = mv.classList.contains('is-static');
      if (isStatic){
        // Aplicar pose fija + marcar loaded para fade-in + skip toda la animación
        const fixHere = () => {
          mv.cameraOrbit = '0deg 80deg auto';
          mv.style.animation = 'none'; // anular cardan-breath del CSS
          mv.setAttribute('data-mv-loaded', 'true');
        };
        if (mv.loaded || mv.modelIsVisible) fixHere();
        else {
          mv.addEventListener('load', fixHere, { once: true });
          mv.addEventListener('model-visibility', () => { if (mv.modelIsVisible) fixHere(); }, { once: true });
          let a = 0;
          const p = setInterval(() => { a++; if (mv.loaded || mv.modelIsVisible || a >= 25){ clearInterval(p); if (!mv.hasAttribute('data-mv-loaded')) fixHere(); } }, 200);
        }
        return; // No sigue al tick + intersection observer
      }

      // Cada medalla con un offset distinto para que no sincronicen exacto
      const offset = (idx * 1.3) % (Math.PI * 2);
      const yawSpeed = 22;   // grados por segundo (rotación principal)
      const pitchAmplitude = 6;  // grados de vaivén pitch
      const baseYaw = 0;  // SIEMPRE arranca de frente (Diego nota: aleatorio causaba "se gira cada vez que recarga")

      let t = 0;
      let raf = null;
      let lastTs = performance.now();

      function tick(ts){
        const dt = (ts - lastTs) / 1000;
        lastTs = ts;
        t += dt;
        const yaw   = (baseYaw + t * yawSpeed) % 360;
        const pitch = 80 + Math.sin(t * 0.7 + offset) * pitchAmplitude;
        mv.cameraOrbit = `${yaw}deg ${pitch}deg auto`;
        raf = requestAnimationFrame(tick);
      }

      // Empezar al cargar el modelo (no antes — model-viewer puede tardar)
      const start = () => {
        if (reduceMotion) {
          // Sin movimiento: solo posición estética fija
          mv.cameraOrbit = `${baseYaw}deg 80deg auto`;
          return;
        }
        if (raf) return;
        lastTs = performance.now();
        raf = requestAnimationFrame(tick);
      };

      // Fade-in al cargar (Diego nota #54: sombra negra el primer segundo)
      const markLoaded = () => mv.setAttribute('data-mv-loaded', 'true');
      const onLoad = () => { markLoaded(); start(); };

      if (mv.loaded || mv.modelIsVisible) {
        onLoad();
      } else {
        // Múltiples eventos del model-viewer + fallbacks robustos
        mv.addEventListener('load', onLoad, { once: true });
        mv.addEventListener('model-visibility', () => { if (mv.modelIsVisible) onLoad(); }, { once: true });
        // Polling cada 200ms hasta que cargue (max 5s)
        let attempts = 0;
        const poll = setInterval(() => {
          attempts++;
          if (mv.loaded || mv.modelIsVisible || attempts >= 25) {
            clearInterval(poll);
            if (!mv.hasAttribute('data-mv-loaded')) onLoad();
          }
        }, 200);
      }

      // Pausar cuando NO está visible (ahorra batería + CPU)
      const io = new IntersectionObserver((entries) => {
        entries.forEach(e => {
          if (e.isIntersecting) {
            if (!raf && !reduceMotion) {
              lastTs = performance.now();
              raf = requestAnimationFrame(tick);
            }
          } else if (raf) {
            cancelAnimationFrame(raf);
            raf = null;
          }
        });
      }, { threshold: 0.01 });
      io.observe(mv);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initMedallions);
  } else {
    initMedallions();
  }
})();
